//import FolderSharedOutlinedIcon from '@mui/icons-material/FolderSharedOutlined';
import AssessmentIcon from '@mui/icons-material/Assessment';
import { MenuItem, MenuItemStateProps } from '@src/components';
import { Features } from '@src/core/features';
import { getNavBarMenuRolesByAction } from '@src/roles';
import { useTheme } from '@src/themes';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSessionContext } from '../authentication';
import { useProjectContext } from '../switch-project';

const StatisticsMenu: FC<MenuItemStateProps> = ({ isMini }) => {
  const { allowAccess } = useSessionContext();
  const { allowedFeature } = useProjectContext();
  const { COLORS } = useTheme();
  const navigate = useNavigate();

  if (!allowAccess(getNavBarMenuRolesByAction(Features.STATISTICS)) || !allowedFeature(Features.STATISTICS)) {
    return <></>;
  }

  const handleClick = () => {
    navigate('/statistics', { replace: true });
  };

  return (
    <MenuItem
      isMini={isMini}
      item={{
        title: 'Estatísticas',
        icon: <AssessmentIcon sx={{ color: COLORS.primary.main }} />,
        ignoreDefaultAvatarStyle: true,
      }}
      onClick={handleClick}
    />
  );
};

export { StatisticsMenu };
